import { Lock01 } from "@untitledui/icons";
import type { ReactNode } from "react";

type LockedNoticeProps = {
  children: ReactNode;
};

export const LockedNotice = (props: LockedNoticeProps) => {
  return (
    <div className="flex items-center gap-md rounded-xl border border-secondary p-xl">
      <Lock01 className="size-5 shrink-0 text-tertiary" />
      <span className="text-sm font-semibold text-secondary">
        {props.children}
      </span>
    </div>
  );
};
